import { Component, OnInit } from '@angular/core';
import { ApiIntegration } from '../../_services/api.integration';
import { Router, ActivatedRoute } from '@angular/router';
import { User } from '../../_models/user';
import { Register } from '../../_models/register';
import { Warehouse } from '../../_models/warehouse';
import { OrderLine } from '../../_models/orderLine';
import { OrderHeader } from '../../_models/orderHeader';
import { Contacts } from '../../_models/contacts';
import { Product } from '../../_models/product';
import { Globals } from '../../_models/globals';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import * as _ from "lodash";
import { AlertService } from '../../_services/alert.service';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';

@Component({
  selector: 'app-edit-order',
  templateUrl: './edit-order.component.html',
  styleUrls: ['./edit-order.component.css']
})

export class EditOrderComponent implements OnInit {

  tabClicked = "selectedProducts";
  step: number = 1;
  destWarehouseId: any;
  progressWidth: any;
  order: OrderHeader = {};
  contacts: any;
  warehouses: any = [];
  activeProducts: any;
  orderLine: OrderLine = {};
  orderLines: OrderLine[] = [];
  activeProduct: Product = {};
  shippingMethod: string;
  shippingOption: string;
  statusText1: string = "";
  statusText2: string = "";
  statusText3: string = "";
  statusText4: string = "";
  statusText5: string = "";
  statusText6: string = "";
  quantity: number = 0;
  deliveryInstructions: string;
  contactAddressText: string;
  addressText: string;
  warehouseAddressText: string;

  actualQuantity: any;
  errorMessage: any;
  changeProductsQ: any;

  warehouse: Warehouse = {
    name: "",
    warehouseType: " ",
    noOfUnits: null,
    status: "",
    totalSpace: null,
    cost: null,
    organizationId: null,
    warehouseId: null,
    accountOwnerId: null,
    addressText: ""
  };

  contact: Contacts = {
    companyName: "",
    contactName: "",
    accountOwners: "",
    accountOwnerContacts: "",
    mobile: "",
    email: "",
    deliveryInstructions: "",
    status: "",
    address1: "",
    address2: "",
    city: "",
    state: "",
    zip: "",
    addressText: "",
    addressId: null,
    accountOwnerId: null,
    organizationId: null,
    accountOwnerContactId: null
  };
  selectedProducts = [];

  constructor(private alertService: AlertService, private http: HttpClient, private g: Globals, private api: ApiIntegration, private route: ActivatedRoute, private router: Router, public user: User, public register: Register) {
    this.g.page = "Edit Order";
    this.progressWidth = "25%";
    this.g.loaderDisplay = "display";
    this.api.getStockTransferDetailsId(this.route.snapshot.params['id'], "1").subscribe((data: OrderHeader) => {
      this.g.loaderDisplay = "";
      this.order = data;
      this.getProductsList();
      this.getAOContactsByStatus("ACTIVE");
      this.getWarehouseColumnList();
      this.orderLines = _.cloneDeep(this.order.lines);
      for (let l of this.orderLines) {
        this.g.loaderDisplay = "display";
        this.api.getNewOrdersProductStockLevel(this.order.accountOwnerId || this.user.accountOwnerId, this.user.organizationId, this.order.warehouseId, l.productId).subscribe((data: any) => {
          this.g.loaderDisplay = "";
          if (data.availableQTY >= 100) {
            l.errorMessage2 = data.availableQTY + ' left in stock';
          } else if (data.availableQTY > 0 && data.availableQTY < 100) {
            l.errorMessage2 = 'Only ' + data.availableQTY + ' left in stock';
          } else {
            l.errorMessage2 = 'No Stock available'
          }
        }, err => {
          this.g.loaderDisplay = "";
          this.alertService.error('Error', err);
        });
      }
    },
      err => {
        this.alertService.error('Error', err);
      });
  }

  getAOContactsByStatus(status) {
    this.g.loaderDisplay = "display";
    this.api.getAOContactsByStatusAndAOIdAndOrgId("1", this.user.accountOwnerId || this.order.accountOwnerId, status).subscribe((data: any) => {
      this.contacts = data;
      for (let c of this.contacts) {
        if (c.contactName === this.order.accountOwnerCustomerName) {
          this.contact = c;
          this.getContactAddress();
          //this.contactAddressText = this.contact.addressText;
        }
      }
    }, err => {
      this.g.loaderDisplay = "";
      this.alertService.error('Error', err);
    });
  }


  tabChange(tab) {
    this.tabClicked = tab
  }

  getContactAddress() {
    //this.contactAddressText = (this.contact || {}).addressText || '';
    this.g.loaderDisplay = "display";
    this.api.getAddressByAddressId((this.contact || {}).addressId, this.contact.organizationId).subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.contactAddressText = data.addressText;
    }, err => {
      this.alertService.error('Error', err);
      this.g.loaderDisplay = "";
    });
  }

  getWarehouseAddress() {
    //this.warehouseAddressText = (this.warehouse || {}).addressText || '';
    this.g.loaderDisplay = "display";
    this.api.getAddressByAddressId((this.warehouse || {}).addressId, this.warehouse.organizationId).subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.warehouseAddressText = data.addressText;
    }, err => {
      this.alertService.error('Error', err);
      this.g.loaderDisplay = "";
    });
  }

  customSearchFn(term: string, item: any = []) {
    term = term.toLowerCase();
    return item.contactName.toLowerCase().indexOf(term) > -1 || (item.companyName && item.companyName.toLowerCase().indexOf(term) > -1);
  }

  getWarehouseColumnList() {
    this.g.loaderDisplay = "display";
    if (this.user.role === "ACCOUNT_OWNER" || this.user.role === "ROLE_USER" || this.user.role === "ROLE_ADMIN") {
      this.api.getWarehouseColumnList(this.user.accountOwnerId || this.order.accountOwnerId, "1").subscribe((data: any) => {
        this.warehouses = data.getWarehousesResponses;
        this.g.loaderDisplay = "";
        for (let w of this.warehouses) {
          if (w.name === this.order.sourceWarehouseName) {
            this.warehouse = w;
            this.getWarehouseAddress();
            //this.warehouseAddressText = this.warehouse.addressText;
          }
        }
      }, err => {
        this.g.loaderDisplay = "";
        this.alertService.error('Error', err);
      });
    } else {
      this.api.getWarehouseColumnList(this.register.Id, "1").subscribe((data: any) => {
        this.warehouses = data.getWarehousesResponses;
        this.g.loaderDisplay = "";
      }, err => {
        this.g.loaderDisplay = "";
        this.alertService.error('Error', err);
      });
    }
  }

  getProductsList() {
    if (this.user.role === "ACCOUNT_OWNER" || this.user.role === "ROLE_USER") {
      this.api.getProductsByWarehouse(this.user.accountOwnerId, (this.warehouse.warehouseId || this.order.warehouseId), "1").subscribe((data: any) => {
        this.activeProducts = data.getProductResponses;
      }, err => {
        this.alertService.error('Error', err);
      });
    } else {
      this.api.getProductsByWarehouse(this.user.accountOwnerId || this.order.accountOwnerId, this.warehouse.warehouseId || this.order.warehouseId, "1").subscribe((data: any) => {
        this.activeProducts = data.getProductResponses;
      }, err => {
        this.alertService.error('Error', err);
      });
    }
  }

  selectProductForEditOrder() {
    if (this.activeProduct !== null && this.activeProduct !== undefined
      && this.activeProduct.productName !== null && this.activeProduct.productName !== undefined) {
      this.orderLine.productId = this.activeProduct.productId;
      this.orderLine.productName = this.activeProduct.productName;
      this.orderLine.sku = this.activeProduct.sku;
      this.orderLine.quantity = this.quantity;
      this.orderLine.errorMessage2 = this.errorMessage;
      this.orderLines.push(_.cloneDeep(this.orderLine));
      this.activeProduct = null;
      this.quantity = undefined;
      this.errorMessage = null;
    }
  }

  recipientInformation() {
    this.step = 1;
    this.progressWidth = "25%";
  }

  backAddProducts() {
    this.step = 2;
    this.progressWidth = "50%";
  }

  /*  selectAddProductInformation() {
        this.statusText1 = "";
        this.statusText2 = "";
        if ( this.contact === null || this.contact === undefined) {
            this.statusText1 = 'Please select customer';
        }
        if ( this.warehouse === null || this.warehouse === undefined) {
            this.statusText2 = 'Please select warehouse';
        }
        if ( this.statusText1 != '' || this.statusText2 != '') {
             return false;
        }

        this.step = 2;
        this.progressWidth = "50%";
        this.getProductsList();
        this.order.warehouseId = this.warehouse.warehouseId;
        this.order.sourceWarehouseName = this.warehouse.name;
        this.order.contactName = this.contact.contactName;
        this.order.accountOwnerContactId = this.contact.accountOwnerContactId;
    }  */
  clearFields() {
    this.contact = null;
    this.warehouse = null;
    this.contactAddressText = null;
    this.warehouseAddressText = null;
    this.statusText1 = "";
    this.statusText2 = "";
    this.statusText3 = "";
    this.statusText4 = "";
    //       ol.quantity = null;
    this.activeProduct = null;
    for (let ol of this.orderLines) {
      let i = this.orderLines.indexOf(ol);
      this.orderLines.splice(i, 1);
    }
    this.statusText5 = "";
    this.order.shippingOption = "";

  }

  selectShippingInformation() {
    this.step = 1;
  }

  /* selectShippingInformation() {
       this.statusText3 = "";
       this.statusText4 = "";
       if (this.orderLines.length === 0) {
              this.statusText3 = 'Please select product';
              return false;
       }
       for ( let ol of this.orderLines) {
               if (ol.quantity === null || ol.quantity === undefined || ol.quantity <=0) {
                   this.statusText4 = 'Please enter quantity as minimum 1';
               }
       }
       if ( this.statusText3 != '' || this.statusText4 != '') {
               return false;
       }
      this.step = 3;
      this.progressWidth = "75%";
      this.selectProductForEditOrder();
   }*/

  reviewAndConfirm() {

    this.statusText1 = "";
    this.statusText2 = "";
    this.statusText3 = "";
    this.statusText4 = "";
    this.statusText5 = "";

    if (this.contact === null || this.contact === undefined) {
      this.statusText1 = 'Please select customer';
    }
    if (this.warehouse === null || this.warehouse === undefined) {
      this.statusText2 = 'Please select warehouse';
    }

    if (this.orderLines.length === 0) {
      this.statusText3 = 'Please select product';
    }
    for (let ol of this.orderLines) {
      if (ol.quantity === null || ol.quantity === undefined || ol.quantity <= 0) {
        this.statusText4 = 'Please enter quantity as minimum 1';
      }
    }
    if (this.statusText3 != '' || this.statusText4 != '' || this.statusText1 != '' || this.statusText2 != '') {
      return false;
    }

    this.getProductsList();
    this.order.warehouseId = this.warehouse.warehouseId;
    this.order.sourceWarehouseName = this.warehouse.name;
    this.order.accountOwnerCustomerName = this.contact.contactName;
    this.order.accountOwnerContactId = this.contact.accountOwnerContactId;
    this.step = 4;
    this.progressWidth = "100%";
  }

  removeProduct(rp) {
    let index = this.orderLines.indexOf(rp);
    this.orderLines.splice(index, 1);
  }

  changeProductQuantity() {
    this.g.loaderDisplay = "display";
    this.api.getNewOrdersProductStockLevel(this.user.accountOwnerId, this.user.organizationId, this.warehouse.warehouseId, this.activeProduct.productId).subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.changeProductsQ = data;
      this.actualQuantity = this.changeProductsQ.availableQTY;
      if (this.actualQuantity >= 100) {
        this.errorMessage = this.actualQuantity + ' left in stock';
      } else if (this.actualQuantity > 0 && this.actualQuantity < 100) {
        this.errorMessage = 'Only ' + this.actualQuantity + ' left in stock';
      } else {
        this.errorMessage = 'No Stock available'
      }
    }, err => {
      this.g.loaderDisplay = "";
      this.alertService.error('Error', err);
    });
  }


  ngOnInit() {
  }

  submitEditOrder() {
    this.g.loaderDisplay = "display";
    //this.order.orderStatus = "SUBMITTED";
    //this.order.lines= _.cloneDeep(this.orderLines);
    // this.order.id = this.route.snapshot.params['id'];
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/createOrderHeaders', {
      "accountOwnerContactId": this.contact.accountOwnerContactId,
      "accountOwnerId": this.user.accountOwnerId || this.order.accountOwnerId,
      "deliveryInstructions": this.order.deliveryInstructions,
      "shippingOption": this.order.shippingOption,
      "shippingMethod": this.order.shippingMethod,
      "organizationId": 1,
      "warehouseId": this.warehouse.warehouseId,
      "lines": this.orderLines,
      "orderType": "ORDER",
      "orderStatus": "SUBMITTED",
      "orderHeaderId": this.route.snapshot.params['id'],
      "orderNumber": this.order.orderNumber
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Order', 'Edited Successfully');
          if (this.user.role == "ACCOUNT_OWNER") {
            this.router.navigate(['/admin/orders']);
          } else {
            this.router.navigate(['/admin/adminOrder']);
          }
        } else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  draftOrder() {
    this.g.loaderDisplay = "display";
    //this.order.orderStatus = "DRAFT";
    // this.order.lines= _.cloneDeep(this.orderLines);
    // this.order.id = this.route.snapshot.params['id'];
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/createOrderHeaders', {
      "accountOwnerContactId": this.contact.accountOwnerContactId,
      "accountOwnerId": this.user.accountOwnerId,
      "deliveryInstructions": this.order.deliveryInstructions,
      "shippingOption": this.order.shippingOption,
      "shippingMethod": this.order.shippingMethod,
      "organizationId": 1,
      "warehouseId": this.warehouse.warehouseId,
      "lines": this.orderLines,
      "orderType": "ORDER",
      "orderStatus": "DRAFT",
      "orderHeaderId": this.route.snapshot.params['id'],
      "orderNumber": this.order.orderNumber
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Draft', 'Edited Successfully');
          this.router.navigate(['/admin/orders']);
        } else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  open() {
    this.selectedProducts = _.cloneDeep(this.activeProducts);
    for (let i = 0; i < this.orderLines.length; i++) {
      let index = this.selectedProducts.findIndex((d) => d.productName === this.orderLines[i].productName);
      if (index > -1) {
        this.selectedProducts.splice(index, 1);
      }
    }
  }
}
